import type { RawMediaCropInput } from '#src/app/shared/components/imageUpload';
import { MIN_IMAGE_DIMENSION_SIZE } from '#src/app/shared/hooks/uppyUploader';

export const validateImageSize = (imageData?: RawMediaCropInput): boolean =>
	imageData ? imageData.h > MIN_IMAGE_DIMENSION_SIZE.HEIGHT || imageData.w > MIN_IMAGE_DIMENSION_SIZE.WIDTH : false;
